

export const ENABLED = 1;
export const DISABLED = 0;
export const PENDING = 2;